import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Torus = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <ellipse cx="12" cy="11" rx="3" ry="2" />
        <ellipse cx="12" cy="12.5" rx="10" ry="8.5" />
      </svg>
    );
  },
);

export default Torus;
